import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const MyRequestReadSlice = createSlice({
  name: "MyRequestReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    myRequestRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successMyRequestRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureMyRequestRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearMyRequestRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  myRequestRead,
  successMyRequestRead,
  failureMyRequestRead,
  clearMyRequestRead,
} = MyRequestReadSlice.actions;

export default MyRequestReadSlice.reducer;
